import { createSelector } from 'reselect';

// Config
import { isStripeCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';
import { getUserIsGuestSelector } from '@redux/reducers/user/userSelector';

const addNewCardState = createSelector(
  [getUserIsGuestSelector, isStripeCheckoutEnabledFeatureActive],
  (isGuest, stripeCheckoutFlowEnabled) => ({
    isGuest,
    stripeCheckoutFlowEnabled,
  }),
);

export default addNewCardState;
